import * as THREE from 'three'
import Experience from '../Experience.js'

/**
 * Environment
 * Scene lighting for Pauline's luxury candle site.
 * - Ambient: warm fill, prevents pitch-black shadows
 * - Directional: soft key light from upper-left
 * - PointLight (flameLight): warm amber glow at wick position,
 *   animated in update() to simulate flickering flame
 */
export default class Environment {
    constructor() {
        this.experience = new Experience()
        this.scene      = this.experience.scene
        this.time       = this.experience.time
        this.debug      = this.experience.debug

        this.setAmbientLight()
        this.setDirectionalLight()
        this.setFlameLight()
        this.setDebug()
    }

    setAmbientLight() {
        this.ambientLight = new THREE.AmbientLight('#5c5338', 1.5)
        this.scene.add(this.ambientLight)
    }

    setDirectionalLight() {
        this.directionalLight = new THREE.DirectionalLight('#f9f2ec', 5)
        this.directionalLight.castShadow = true
        this.directionalLight.shadow.camera.far = 20
        this.directionalLight.shadow.mapSize.set(1024, 1024)
        this.directionalLight.shadow.normalBias = 0.05
        this.directionalLight.position.set(-3, 5, 3)
        this.scene.add(this.directionalLight)
    }

    setFlameLight() {
        // Warm amber point light at wick — intensity animated each frame
        this.flameLight = new THREE.PointLight('#ff6b2b', 2.5, 6)
        // Wick tip position (adjusted once Candle.js sets model scale)
        this.flameLight.position.set(0, -0.14, 0)
        this.scene.add(this.flameLight)
    }

    setDebug() {
        if (!this.debug.active) return
        const folder = this.debug.ui.addFolder('Environment')
        folder.add(this.ambientLight, 'intensity').min(0).max(3).step(0.01).name('Ambient')
        // --- DIRECTIONAL LIGHT ---
    folder.add(this.directionalLight, 'intensity').min(0).max(10).step(0.1).name('Dir Light Int.')

    // Створюємо об'єкт-хелпер для кольору
    const dirColorUpdates = {
        color: this.directionalLight.color.getHex() // беремо поточний колір
    }

    folder
        .addColor(dirColorUpdates, 'color')
        .name('Dir Light Color')
        .onChange(() => {
            // Оновлюємо колір світла при зміні в UI
            this.directionalLight.color.set(dirColorUpdates.color)
        })

        // folder.add(this.directionalLight, 'intensity').min(0).max(5).step(0.01).name('Dir Light')
        // folder.add(this.directionalLight.color, 'r').min(0).max(1).step(0.01).name('Dir R')
        // folder.add(this.directionalLight.color, 'g').min(0).max(1).step(0.01).name('Dir G')
        // folder.add(this.directionalLight.color, 'b').min(0).max(1).step(0.01).name('Dir B')
        folder.add(this.flameLight, 'intensity').min(0).max(8).step(0.01).name('Flame Light')
        folder.add(this.flameLight.position, 'y').min(0).max(4).step(0.01).name('Flame Y')
        folder.add(this.flameLight.color, 'r').min(0).max(1).step(0.01).name('Flame R')
        folder.add(this.flameLight.color, 'g').min(0).max(1).step(0.01).name('Flame G')
        folder.add(this.flameLight.color, 'b').min(0).max(1).step(0.01).name('Flame B')
    }

    update() {
        // Flicker: fast noise using two overlapping sin waves
        const t = this.time.elapsed * 0.001
        const flicker = Math.sin(t * 7.3) * 0.15
                      + Math.sin(t * 13.1) * 0.1
                      + 1.0
        this.flameLight.intensity = 2.5 * flicker
    }
}
